import { Action } from 'redux';

import { IUpload } from '@models';

import { RequestStatus } from '../request';

export const GETTING_UPLOADS = 'GETTING_UPLOADS';
export const GOT_UPLOADS = 'GOT_UPLOADS';
export const CANCELLED_UPLOAD = 'CANCELLED_UPLOAD';
export const CANCELLING_UPLOAD = 'CANCELLING_UPLOAD';
export const REMOVED_UPLOAD = 'REMOVED_UPLOAD';
export const REMOVING_UPLOAD = 'REMOVING_UPLOAD';
export const UPLOADS_LOCAL_CHANGE = 'UPLOADS_LOCAL_CHANGE';

export interface IUploadsState {
  status: RequestStatus;
  uploads: IUpload[];
  // This is used to keep track of if any meta information about the
  // uploads has changed. The value itself is not important.
  localChanges: number;
}

export interface IGotUploadsAction extends Action {
  payload: IUpload[];
}

export interface IUploadAction extends Action {
  payload: IUpload;
}

export type UploadsActionTypes = IUploadAction | Action | IGotUploadsAction;
